import React from 'react';

const ForecastBarChart = ({ rows }) => {
  const maxValue = Math.max(...rows.map(row => row.value), 1);

  return (
    <div className="space-y-4">
      {rows.map(row => (
        <div key={row.label}>
          <div className="mb-2 flex items-center justify-between text-xs">
            <span className="font-bold text-slate-700">{row.label}</span>
            <span className="font-black text-slate-900">{row.formattedValue}</span>
          </div>
          <div className="h-3 overflow-hidden rounded-full bg-slate-100">
            <div
              className={`h-full rounded-full ${row.color}`}
              style={{ width: `${Math.max((row.value / maxValue) * 100, row.value > 0 ? 4 : 0)}%` }}
            />
          </div>
          <p className="mt-1 text-[10px] font-medium text-slate-400">
            {row.count} {row.count === 1 ? 'mulighet' : 'muligheter'}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ForecastBarChart;